import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CrearNotasDeCreditoForm, Props as FormProps } from "./form";
import { FiltroFacturas } from "app/models/requireme";

export interface Props {
    /**Folios de las guias seleccionadas para los contrarecibos*/
    value: number;
    filtro: FiltroFacturas;
    onChange: (x: number) => void;
}


let sugerenciaAnterior: any;
/**Componente de selección */
export class CrearNotaDeCreditoEdit extends React.PureComponent<Props> {
    constructor(props) {
        super(props);

        this.state = { filtro: this.props.filtro};
    }
    render() {
        return <CrearNotasDeCreditoForm
            onChange={this.props.onChange}
            value={this.props.value}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/notacredito/generarnotasdecredito/edit.tsx